import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../api";
import { RTL_LANGUAGES, SUPPORTED_LOCALES } from "./index";

export function useClientTranslations(namespace = "common") {
	const { t, i18n } = useTranslation(namespace);

	const changeLanguage = useCallback(
		async (newLocale: string) => {
			if (!SUPPORTED_LOCALES.includes(newLocale as never)) {
				console.error(`Unsupported locale: ${newLocale}`);
				return;
			}

			// Switch language immediately in the client
			await i18n.changeLanguage(newLocale);

			// Persist preference to backend (fire-and-forget)
			try {
				await api.patch("/api/user/display-language", {
					displayLanguage: newLocale,
				});
			} catch (error) {
				console.error("Error saving language preference:", error);
			}
		},
		[i18n],
	);

	return {
		t,
		locale: i18n.language,
		changeLanguage,
		isRTL: RTL_LANGUAGES.includes(i18n.language),
		direction: RTL_LANGUAGES.includes(i18n.language)
			? ("rtl" as const)
			: ("ltr" as const),
	};
}
